<div *ngIf="!!task.id">Id: {{task.id}}</div>

<form (ngSubmit)="onSubmit()" #taskForm="ngForm">
  <label for="title">Title: </label>
  <input id="title" name="title" #taskTitle [(ngModel)]="task.title" placeholder="title">

  <label for="state">State: </label>
  <select name="state" [(ngModel)]="task.taskState">
    <option *ngFor="let mapping of taskStateMappings"
        [ngValue]="mapping.value">{{mapping.name}}</option>
  </select>
</form>
